import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../../../../_constants/validation-format-constants';
import { ARAdjustmentWriteOffItemParametersDto } from './ar-adjustment-writeoff-item-parameters-dto';

export class ARAdjustmentWriteOffParameterDto {
    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    writeOffDate: Date;

    @Type(() => ARAdjustmentWriteOffItemParametersDto)
    items: ARAdjustmentWriteOffItemParametersDto[];

    communityId: number;
    managementCompanyId: number;
    adjustmentId: number;
    clearCache: boolean;
}
